import { useAuthContext } from "src/auth/AuthContext";
import FundsForm from "./FundsForm";
import { fundService } from "src/service/FundService";

const FundsAdd = () => {
    const { user } = useAuthContext();
    return <FundsForm
        fundId={-1}
        organizationId={user?.data?.organizationId}
        onSubmit={(entry) => fundService.add(entry)}
        header='Neuer Fonds'
    />;
};

export default FundsAdd;
